import MilkType from "./MilkType";

export default function TbWC({data}) {
    // eslint-disable-next-line
    let lr = data.data;

    function SiloRow({num}){
      // eslint-disable-next-line
      let lbs = eval("lr.wc_"+num+"_lbs");
      // eslint-disable-next-line
      let temp = eval("lr.wc_"+num+"_temp");
      // eslint-disable-next-line
      let pa = eval("lr.wc_"+num+"_pa") === "Yes";
      // eslint-disable-next-line
      let mTypeId = eval("lr.tk_tk"+num+"_type");
      let mType = MilkType.find(x => x.id === 0);
      if (mTypeId === undefined) {
        if (pa) {
          mType = MilkType.find(x => x.id === 6);
        }
      }
      else {
        mType = MilkType.find(x => x.id === mTypeId);
      }
      return (
        <tr>
          <td className={mType.style}>{num} {mType.id > 0 && <sup>{mType.code}</sup>}</td>
          <td className={mType.style}>{lbs}</td>
          <td className={mType.style}>{temp}</td>
        </tr>
      )
    }

    return (
      <>
        <div className="card card-table mb-4 rounded-1 shadow-sm">
          <div className="card-header py-2">
            <h4 className="my-0">Whey Cream</h4>
          </div>
          <div className="card-body nopadding">
            <table className="table table-sm my-0 tbl">
              <thead>
                <tr>
                  <th scope="col">Silo</th>
                  <th scope="col">Lbs</th>
                  <th scope="col">Temp</th>
                </tr>
              </thead>
              <tbody>
                <SiloRow num="14" />
              </tbody>
            </table>
          </div>
        </div>

      </>
    )
}